import React from 'react';
import PageContainer from '@jumbo/components/PageComponents/layouts/PageContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';

import NewsManagement from './NewsManagement';
import { Card } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  cardRoot: {
    padding: 50,
  },
}));

const News = () => {
  const classes = useStyles();

  return (
    <PageContainer heading={'ساخت خبر'}>
      <Card className={classes.cardRoot}>
        <NewsManagement />
      </Card>
    </PageContainer>
  );
};

export default News;
